import { tryExtractGoogleDriveId } from "@/utils/util";
import { LoadingIframe } from "./LoadingIframe";

export interface DocumentPreviewProps extends React.HTMLAttributes<HTMLIFrameElement> {
  url: string;
}

/**
 * Component to preview a document using Google's undocumented viewer.
 * See: https://gist.github.com/tzmartin/1cf85dc3d975f94cfddc04bc0dd399be#google-drive
 *
 * TODO: generic PDF files can be previewed in an iframe like this:
 * `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`
 */
export const GoogleDriveFilePreview: React.FC<DocumentPreviewProps> = ({ url, ...iframeProps }) => {
  // Validate and parse the URL
  const parsedUrl = validateUrl(url);
  if (!parsedUrl) return <>Invalid URL: {url}</>;

  // Extract the Google Drive file ID from the URL
  const driveFileId = tryExtractGoogleDriveId(parsedUrl);
  if (!driveFileId) return "Not a valid Google Drive file URL: " + url;

  return (
    <LoadingIframe
      src={`https://docs.google.com/document/d/${driveFileId}/preview`}
      style={{ border: "none" }}
      {...iframeProps}
    />
  );
};

function validateUrl(url: string): URL | false {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") return false;
    return parsedUrl;
  } catch {
    return false;
  }
}
